export const REMOVE_USER = 'remove/user'
export const LOGIN_USER = 'login/user'
export const LOAD_USERS = 'loading/user'
export const LOGIN_USER_ERROR = 'error/userLogin'